import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';

const RoleDetails = ({ selectedRole }) => {
   const [rolePermissions, setRolePermissions] = useState([]);
   const [availablePermissions, setAvailablePermissions] = useState([]);
    const [error, setError] = useState(null)
   useEffect(() => {
       const fetchRoleDetails = async () => {
          if (!selectedRole) return;
          try {
            const response = await api.get(`/roles/roles/${selectedRole.id}/permissions`);
            if (response && response.data){
              setRolePermissions(response.data);
            }
             else{
                setError('Неправильный формат данных с сервера');
                 return;
              }
            const allPermissionsResponse = await api.get('/roles/permissions');
           if (allPermissionsResponse && allPermissionsResponse.data){
                const filteredPermissions = allPermissionsResponse.data.filter(
                   permission => !response.data.some(rp => rp.id === permission.id)
                );
                  setAvailablePermissions(filteredPermissions);
               } else {
                  setError('Неправильный формат данных с сервера');
                  return;
              }

          } catch (error) {
           console.error("Ошибка при загрузке подробностей ролей:", error);
            setError('Ошибка при загрузке подробностей ролей')
         }
       };

       fetchRoleDetails();
   }, [selectedRole]);

   const handleAddPermission = async (permissionId) => {
       try {
         await api.post(`/roles/roles/${selectedRole.id}/permissions/${permissionId}`);
         const response = await api.get(`/roles/roles/${selectedRole.id}/permissions`);
         if (response && response.data){
              setRolePermissions(response.data);
            }
           else{
              setError('Неправильный формат данных с сервера');
               return;
              }
          const allPermissionsResponse = await api.get('/roles/permissions');
           if (allPermissionsResponse && allPermissionsResponse.data) {
            const filteredPermissions = allPermissionsResponse.data.filter(
                permission => !response.data.some(rp => rp.id === permission.id)
             );
            setAvailablePermissions(filteredPermissions);
         } else{
             setError('Неправильный формат данных с сервера')
         }
     } catch (error) {
        console.error('Ошибка при добавлении разрешения:', error)
        setError('Ошибка при добавлении разрешения');
     }
 };

 const handleRemovePermission = async (permissionId) => {
     try {
        await api.delete(`/roles/roles/${selectedRole.id}/permissions/${permissionId}`);
         const response = await api.get(`/roles/roles/${selectedRole.id}/permissions`);
          if (response && response.data){
             setRolePermissions(response.data);
           }
           else{
            setError('Неправильный формат данных с сервера');
             return;
            }
           const allPermissionsResponse = await api.get('/roles/permissions');
           if(allPermissionsResponse && allPermissionsResponse.data){
                 const filteredPermissions = allPermissionsResponse.data.filter(
                     permission => !response.data.some(rp => rp.id === permission.id)
                 );
                  setAvailablePermissions(filteredPermissions);
             }
           else{
             setError('Неправильный формат данных с сервера')
           }
     } catch (error) {
        console.error('Ошибка при удалении разрешения:', error);
       setError('Ошибка при удалении разрешения')
     }
 };

 if (!selectedRole) {
     return <p>Выберите роль для просмотра деталей</p>;
 }
   if (error) {
     return <p> {error} </p>
   }
 return (
     <div>
         <h2>Детали Роли: {selectedRole.name}</h2>
         <h3>Добавленные Права:</h3>
         <ul>
             {rolePermissions && rolePermissions.map(permission => (
                 <li key={permission.id}>
                     {permission.name}
                      <button onClick={() => handleRemovePermission(permission.id)}>Удалить</button>
                 </li>
             ))}
         </ul>
         <h3>Доступные права:</h3>
         <ul>
             {availablePermissions && availablePermissions.map(permission => (
                 <li key={permission.id}>
                     {permission.name}
                      <button onClick={() => handleAddPermission(permission.id)}>Добавить</button>
                 </li>
             ))}
         </ul>
     </div>
 );
};

export default RoleDetails;
